import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();

  const handlePage = data => {
    history.push({
      pathname: '/definicion/puesto',
      state: {
        jobTitle: data[6],
        department: data[5],
        isComingFrom: '/definicion/seleccion/puesto',
      },
    });
  };

  return { handlePage };
};

export default useRoute;
